import AboutComponent from "./Component";

const About = () => {
  return <AboutComponent />;
};
export default About;
